import { cn } from "@/lib/cn";
import type { ConversationTone } from "../data/types";

const tones: Record<ConversationTone, string> = {
  leaf: "bg-papaya-leaf/15 text-papaya-leaf",
  papaya: "bg-papaya/20 text-papaya-deep",
  deep: "bg-papaya-deep/15 text-papaya-deep",
  seed: "bg-papaya-seed/10 text-papaya-seed dark:bg-papaya/10 dark:text-papaya",
  mint: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
};

type ConversationAvatarProps = {
  conversation: {
    initials: string;
    tone: ConversationTone;
    online?: boolean;
    name: string;
  };
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizes = {
  sm: "h-9 w-9 text-xs",
  md: "h-11 w-11 text-sm",
  lg: "h-28 w-28 text-3xl",
};

export function ConversationAvatar({
  conversation,
  size = "md",
  className,
}: ConversationAvatarProps) {
  return (
    <div className={cn("relative shrink-0", className)}>
      <div
        className={cn(
          "inline-flex items-center justify-center rounded-full font-semibold",
          sizes[size],
          tones[conversation.tone],
        )}
        aria-hidden
      >
        {conversation.initials}
      </div>
      {conversation.online ? (
        <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full border-2 border-surface bg-papaya-leaf" />
      ) : null}
      <span className="sr-only">{conversation.name}</span>
    </div>
  );
}
